import { render, staticRenderFns } from "./outboundOrder.vue?vue&type=template&id=60b52bb1&scoped=true&"
import script from "./outboundOrder.vue?vue&type=script&lang=js&"
export * from "./outboundOrder.vue?vue&type=script&lang=js&"
import style0 from "./outboundOrder.vue?vue&type=style&index=0&id=60b52bb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b52bb1",
  null
  
)

export default component.exports